export default __webpack_public_path__ + "static/media/milling_machine.c5341b29.png";